import { IHttpClient } from "../../../lib/http";
import { Reservation } from "../../modification/model";
import { PropertyInfoData } from "../index";

export interface PaymentConfigDto {
  active: boolean;
  creationDate: string;
  id: string;
  lastUpdate: string;
  maxRelease: {
    duration: number;
    chronoUnit: string;
  };
  minRelease: {
    duration: number;
    chronoUnit: string;
  };
  order: number;
  paymentInAdvance: boolean;
  paymentPercentage: number;
  properties: {
    apiKey?: string;
    terminalId?: string;
    merchantId?: string;
    merchantPassword?: string;
    merchantAccount?: string;
    chargeDeposit: string;
    secure: string;
    paymentMethods: string;
    allowTokenize?: string;
  };
  propertyTicker: string;
  restrictions: { [key: string]: unknown };
  ticker: string;
  translations: {
    description: string;
    language: string;
    title: string;
  }[];
  type: string;
}

export class Api {
  readonly propertyTicker: string;
  readonly apiClient: IHttpClient;

  constructor(apiClient: IHttpClient, propertyTicker: string) {
    this.propertyTicker = propertyTicker;
    this.apiClient = apiClient;
  }

  async getCreditCardUrl(reservationId: string, backofficeUserEmail?: string) {
    try {
      const data = await this.apiClient.post<{ backofficeUserEmail?: string }, { url: string }>(
        `/api/property/${this.propertyTicker}/engine/payments/paynopainproxy/cards/reservation/${reservationId}/link`,
        { backofficeUserEmail }
      );
      return data.url;
    } catch (e) {
      throw new Error("url not exists");
    }
  }

  async getReservation(reservationId: string): Promise<Reservation> {
    return this.apiClient.get<Reservation>(
      `/api/properties/${this.propertyTicker}/reservations/${reservationId}/masked`
    );
  }

  async getReservationToken(reservationId: string): Promise<string> {
    return this.apiClient.post<undefined, string>(
      `/api/properties/${this.propertyTicker}/reservations/${reservationId}/token`,
      undefined
    );
  }

  async getBackofficePaymentConfigs(): Promise<PaymentConfigDto[]> {
    return this.apiClient.get<PaymentConfigDto[]>(
      `/api/backoffice/${this.propertyTicker}/payments`
    );
  }

  async getPropertyData(): Promise<Record<string, PropertyInfoData>> {
    return this.apiClient.get<Record<string, PropertyInfoData>>(
      `/api/property/${this.propertyTicker}/es/propertyData`
    );
  }
}
